import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowLeft, ClipboardCheck, FileText } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { GrnToFinalise } from '@/components/grn/GrnToFinalise';
import { GrnList } from '@/components/grn/GrnList';
import { GrnPreviewDialog } from '@/components/grn/GrnPreviewDialog';

/** Goods Receipt Notes — staff finalise each delivery's GRN; Accounts download and tick them booked. */
export default function GrnPage() {
  const navigate = useNavigate();
  const [params, setParams] = useSearchParams();
  const tab = params.get('tab') === 'list' ? 'list' : 'finalise';
  const entry = params.get('entry');
  const [key, setKey] = useState(0);
  const setP = (next) => setParams(Object.fromEntries(Object.entries({ tab, ...next }).filter(([, v]) => v)), { replace: true });
  return (
    <div className="min-h-screen bg-gray-50" data-testid="grn-page">
      <div className="sticky top-0 z-10 flex items-center gap-3 border-b bg-white px-4 pb-3 pt-10 md:pt-3">
        <Button variant="ghost" size="sm" onClick={() => navigate(-1)} data-testid="grn-back"><ArrowLeft className="h-4 w-4" /></Button>
        <div className="min-w-0 flex-1">
          <h1 className="text-lg font-bold text-gray-900">Goods Receipt Notes</h1>
          <p className="text-xs text-gray-500">One GRN per supplier delivery, priced at the PO rates with GST — finalise it once counting is done.</p>
        </div>
      </div>
      <div className="mx-auto max-w-7xl p-4">
        <Tabs value={tab} onValueChange={(v) => setP({ tab: v })}>
          <TabsList className="mb-4">
            <TabsTrigger value="finalise" data-testid="grn-tab-finalise"><ClipboardCheck className="mr-1.5 h-4 w-4" />To finalise</TabsTrigger>
            <TabsTrigger value="list" data-testid="grn-tab-list"><FileText className="mr-1.5 h-4 w-4" />GRN list (Accounts)</TabsTrigger>
          </TabsList>
          <Card><CardContent className="pt-4">
            <TabsContent value="finalise" className="mt-0"><GrnToFinalise onOpen={(id) => setP({ entry: id })} refreshKey={key} /></TabsContent>
            <TabsContent value="list" className="mt-0"><GrnList refreshKey={key} onChanged={() => setKey((k) => k + 1)} /></TabsContent>
          </CardContent></Card>
        </Tabs>
      </div>
      <GrnPreviewDialog entryId={entry} onClose={() => setP({ entry: null })} onDone={() => { setKey((k) => k + 1); setP({ tab: 'list', entry: null }); }} />
    </div>
  );
}
